/* Back-to-School product grid: tab switching + view more */
(function () {
  'use strict';

  function initGrid(root) {
    if (root.dataset.btsGridReady === 'true') return;
    root.dataset.btsGridReady = 'true';

    var tabs = root.querySelectorAll('[data-bts-tab]');
    var panels = root.querySelectorAll('[data-bts-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.getAttribute('data-bts-tab');
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-bts-panel') === index);
        });
      });
    });

    root.querySelectorAll('.bts-product-card').forEach(initSwatches);

    root.querySelectorAll('[data-bts-view-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('[data-bts-panel]');
        if (!panel) return;
        panel.querySelectorAll('.bts-product-card--extra').forEach(function (card) {
          card.hidden = false;
        });
        btn.parentElement.remove();
      });
    });
  }

  /* Color swatches: clicking one swaps the card's image, price, badge and links
     to the variant(s) of that color, using data-* precomputed in Liquid. */
  function initSwatches(card) {
    var swatches = card.querySelectorAll('[data-bts-swatch]');
    if (!swatches.length) return;

    var cta = card.querySelector('.bts-product-card__cta');
    if (cta && !cta.dataset.label) {
      cta.dataset.label = cta.textContent.trim();
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) {
          s.classList.toggle('is-active', s === swatch);
        });
        applyVariant(card, swatch.dataset);
      });
    });

    /* Liquid pre-selects the default variant's dot; if none matched
       (e.g. option data mismatch), highlight the first dot visually
       without swapping the card's default image/price. */
    if (!card.querySelector('[data-bts-swatch].is-active')) {
      swatches[0].classList.add('is-active');
    }
  }

  function applyVariant(card, data) {
    var priceEl = card.querySelector('.bts-product-card__price-current');
    if (priceEl && data.price) priceEl.textContent = data.price;

    var priceWrap = card.querySelector('.bts-product-card__price');
    var compareEl = card.querySelector('.bts-product-card__price-compare');
    if (data.compare) {
      if (!compareEl && priceWrap) {
        compareEl = document.createElement('s');
        compareEl.className = 'bts-product-card__price-compare';
        priceWrap.appendChild(compareEl);
      }
      if (compareEl) {
        compareEl.textContent = data.compare;
        compareEl.hidden = false;
      }
    } else if (compareEl) {
      compareEl.hidden = true;
    }

    var savingsEl = card.querySelector('.bts-product-card__savings');
    if (savingsEl) savingsEl.innerHTML = data.savings || '&nbsp;';

    var media = card.querySelector('.bts-product-card__media');
    var badge = card.querySelector('.bts-product-card__discount');
    if (data.discount) {
      if (!badge && media) {
        badge = document.createElement('span');
        badge.className = 'bts-product-card__discount';
        media.prepend(badge);
      }
      if (badge) {
        badge.textContent = data.discount;
        badge.hidden = false;
      }
    } else if (badge) {
      badge.hidden = true;
    }

    var img = media ? media.querySelector('img') : null;
    if (img && data.image) {
      img.src = data.image;
      if (data.srcset) {
        img.srcset = data.srcset;
      } else {
        img.removeAttribute('srcset');
      }
    }

    if (data.url) {
      card.querySelectorAll('a.bts-product-card__media, .bts-product-card__title a').forEach(function (link) {
        link.href = data.url;
      });
    }

    var cta = card.querySelector('.bts-product-card__cta');
    if (cta) {
      var available = data.available !== 'false';
      cta.classList.toggle('bts-btn--primary', available);
      cta.classList.toggle('bts-product-card__cta--soldout', !available);
      cta.textContent = available ? (cta.dataset.label || 'Buy Now') : 'Sold Out';
      if (cta.tagName === 'A') {
        if (available && data.url) {
          cta.setAttribute('href', data.url);
        } else if (!available) {
          cta.removeAttribute('href');
        }
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-bts-product-grid]').forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-bts-product-grid]');
    if (root) initGrid(root);
  });
})();
